"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateFormat = void 0;
var DateFormat;
(function (DateFormat) {
  DateFormat["FULL_DATE"] = "LL";
  DateFormat["FULL_DATE_SHORT"] = "ll";
  DateFormat["FULL_DATE_WITH_TIME"] = "LLL";
  DateFormat["FULL_DATE_WITH_FULL_TIME"] = "DD MMMM YYYY, HH:mm:ss";
  DateFormat["FULL_DATE_WITH_TIME_SHORT"] = "lll";
  DateFormat["DATE_NUMERAL"] = "L";
  DateFormat["TIME"] = "LT";
  DateFormat["TIME_WITH_SECONDS"] = "LTS";
  DateFormat["FULL_DATE_SHORT_WITH_TIME"] = "ll LT";
  DateFormat["MONTH_ONLY"] = "MMMM";
  DateFormat["MONTH_ONLY_SHORT"] = "MMM";
  DateFormat["DAY_ONLY"] = "D";
  DateFormat["MONTH_AND_DAY"] = "MMMM D";
  DateFormat["MONTH_AND_DAY_SHORT"] = "MMM D";
  DateFormat["MONTH_AND_DAY_AND_TIME"] = "MMM D LTS";
  DateFormat["YEAR_AND_MONTH"] = "MMMM Y";
  DateFormat["YEAR_AND_MONTH_SHORT"] = "MMM Y";
  DateFormat["DAY_NAME"] = "dddd";
  DateFormat["ISO_FULL_DATE_WITH_SECONDS"] = "YYYY-MM-DDTHH:mm:ss";
  DateFormat["YEAR_MONTH_DAY_HOUR_MINUTE_SECOND"] = "YYYY-MM-DD HH:mm:ss";
  DateFormat["ISO_FULL_DATE"] = "YYYY-MM-DDTHH:mm";
  DateFormat["FULL_YEAR"] = "YYYY";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));